const UNKNOWN_LABEL = "(unknown)";

let regionDisplay = null;
try {
  if (typeof Intl !== "undefined" && Intl.DisplayNames) {
    regionDisplay = new Intl.DisplayNames(["en"], { type: "region" });
  }
} catch (_) {
  regionDisplay = null;
}

export function isoToFlag(iso) {
  if (!iso || typeof iso !== "string") return "";
  const code = iso.trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(code)) return "";
  const base = 0x1f1e6;
  const a = "A".charCodeAt(0);
  return String.fromCodePoint(
    base + code.charCodeAt(0) - a,
    base + code.charCodeAt(1) - a,
  );
}

export function countryDisplayName(iso) {
  if (!iso) return "";
  const code = String(iso).trim().toUpperCase();
  if (code === UNKNOWN_LABEL.toUpperCase()) return "Unknown";
  if (!regionDisplay) return code;
  try {
    return regionDisplay.of(code) || code;
  } catch (_) {
    return code;
  }
}

export function isUnknownCountry(iso) {
  return String(iso || "").trim().toLowerCase() === UNKNOWN_LABEL;
}

export { UNKNOWN_LABEL };
